import React from 'react';
import Header from 'gatsby-theme-carbon/src/components/Header';

const CustomHeader = (props) => (
  <Header {...props}>
    NFTx&nbsp;<span>Developers</span>
  </Header>
);

export default CustomHeader;
